<!--
 - Author : 003.
 - Date   : 2019/6/4.
 - File   : todayRK.仓库区:1.0版本今日入库，2.0版本今日采购公示
 -->

<template>
  <ckTitle title="今日采购公示" class="today-rk">
    <div class="publicity" v-if="purchaseList && purchaseList.length>0">
      <p class="publicity-title">
        今日采购食品共计<span>{{buyTotal}}</span>件
      </p>
      <ul class="publicity-ul">
        <li v-for="(item, index) in purchaseList" :key="index">
          <div class="li-l" @click="showGYS(item, index)">
            <p>{{item.supplierName}}</p>
            <p>{{item.telephone || '暂无'}}</p>
          </div>
          <div class="li-r">采购<span>{{item.num}}</span>件
            <i class="iconfont icon-mingxi" @click="getTodayDetailList(item.supplierId, index)"></i></div>
        </li>
      </ul>
    </div>
    <div class="no-the-data h420" v-if="purchaseList && purchaseList.length===0">
      <div>
        <i class="iconfont icon-ruku dzi" style="font-size: 40px;margin-bottom: 5px"></i>
        <p>今日暂无采购公示</p>
      </div>
    </div>
    <!--公司详情弹窗-->
    <datePopover title="供应商信息"
        width="430px"
        v-if="showDetail"
        :aqiMsg="currentGys"
        class="supp-info"
        @closeEvent="showDetail=false">
      <div class="h1">{{currentGys.supplierName}}</div>
      <div class="info-detail">
        <div class="info-detail-l">纳税人识别号：</div>
        <div class="info-detail-r">{{currentGys.identificationCode}}</div>
      </div>
      <div class="info-detail">
        <div class="info-detail-l">联系电话：</div>
        <div class="info-detail-r">{{currentGys.telephone || '暂无'}}</div>
      </div>
      <div class="imgs-list">
        <div class="imgs-list-item" v-for="item in currentGys.fileIdList" :key="item"
            @click="showPic(imgUrl+item)">
          <div>
            <img :src="imgUrl+item" alt="">
          </div>
        </div>
      </div>
    </datePopover>
     <!--采购明细弹窗-->
    <datePopover
        class="buy-detail"
        title="采购明细"
        width="600px"
        v-if="showBuyDetail"
        :aqiMsg="currentPos"
        @closeEvent="showBuyDetail=false">
      <div class="pre-view">
      </div>
      <el-table
          :data="tableData"
          class="my-table"
          style="width: 100%">
        <el-table-column
            prop="goodsName"
            label="食品名称">
          <template slot-scope="scope">
            <span class="food-name">{{scope.row.goodsName}}</span>
          </template>
        </el-table-column>
        <el-table-column
            prop="goodsTypeCn"
            align="center"
            label="食品类别">
          <template slot-scope="scope">
            <span class="result">{{scope.row.goodsTypeCn}}</span>
          </template>
        </el-table-column>
        <el-table-column
            prop="number"
            align="center"
            label="数量">
          <template slot-scope="scope">
            <span class="result">{{scope.row.number}}</span>
          </template>
        </el-table-column>
        <el-table-column
            prop="productionDate"
            align="center"
            label="生产日期">
          <template slot-scope="scope">
            <span class="time">{{scope.row.productionDate}}</span>
          </template>
        </el-table-column>
      </el-table>
    </datePopover>
  </ckTitle>
</template>

<script>
  export default {
    name: 'todayRK',
    data () {
      return {
        deptId: this.$route.query.deptId,
        imgUrl: this.$store.getters.fileApi,
        imgPic: require('../../assets/images/shitang/area_btn.png'),
        list: [],
        tableData: [],
        purchaseList: [],
        buyTotal: null,
        showBuyDetail: false,
        currentPos: {},
        currentGys: {},
        showDetail: false,
        tmpIndex: null,
        tmpIndex1: null
      }
    },
    mounted() {
      this.getTodaypurchase()
      document.addEventListener('click', e => {
        if (!this.$el.contains(e.target)) {
          this.showBuyDetail = false
          this.showDetail = false
        }
      }, {passive: true})
    },
    methods: {
      /**
       * 获取今日采购公示
       * @author wanghongling
       * @createTime 2019/07/24
       */
      getTodaypurchase() {
        let params = {
          departmentId: this.deptId
        }
        this.$request.pcGoodsTodayPurchaseGet(params).then(res => {
          console.log('获取今日采购公示', res)
          if (!this.$utils.isEmptyObject(res)) {
            this.purchaseList = res.resultList
            this.buyTotal = res.total
          }
        }).catch(() => {
          // do something
        })
      },
      /**
       * 根据供应商id获取今日采购明细(ndj)
       * @author wanghongling
       * @param index
       * @param e
       * @createTime 2019/07/24
       */
      getTodayDetailList(e, index) {
        this.showDetail = false
        if (this.tmpIndex === index) {
          this.showBuyDetail = !this.showBuyDetail
          this.tmpIndex = index
        } else {
          this.showBuyDetail = true
          this.$request.pcGoodsTodayDetailListGet({supplierId: e}).then(res => {
            console.log('根据供应商id获取今日采购明细', res)
            if (!this.$utils.isEmptyObject(res)) {
              this.tableData = res
              this.tmpIndex = index
            }
          }).catch(e => {
            console.log(e)
            this.tmpIndex = null
            this.tableData = {}
            this.showBuyDetail = false
          })
        }
      },
      /**
       * 显示供应商详情
       * @author wanghongling
       * @createTime 2019/07/24
       */
      showGYS(e, index) {
        this.showBuyDetail = false
        if (this.tmpIndex1 === index) {
          this.showDetail = !this.showDetail
          this.tmpIndex1 = index
        } else {
          console.error('执行这里22？')
          this.$request.pcSupplierGet({batchId: e.batchId, supplierId: e.supplierId}).then(res => {
            this.showDetail = true
            this.currentGys = res
            this.tmpIndex1 = index
          }).catch(e => {
            console.log(e)
            this.currentGys = {}
            this.showDetail = false
            this.tmpIndex1 = null
          })
        }
      },
      /**
       * 显示查看图片框
       * @author: whl
       * @createDate: 2019/07/23
       * @param item 图片信息
       * @return {Object}
       */
      showPic (item) {
        this.$superMessage('凭证照片查看', '', {imgPic: item, btnShow: false}).then(() => {
          // do something
        }).catch(() => {
          // do something
        })
      }
    }
  }
</script>

<style lang="less" rel="stylesheet/less">
  @import '../../assets/less/color';
  .today-rk {
    position: relative;
    z-index: 100;
    .ck-ct {
      .list li {
        position: relative;
        padding-top: 5px;
        padding-bottom: 8px;
        margin-bottom: 2px;
        border-bottom: 1px solid #0b4045;

        .left {
          position: absolute;
          width: 160px;
          cursor: pointer;
          img {
            width: 100%;
            height: 84px;
            object-fit: cover;
          }
        }

        .yi-ping-yi-ma {
          &:after {
            position: absolute;
            right: 2px;
            top: 4px;
            width: 65px;
            height: 24px;
            content: '';
            background: url("../../assets/images/shitang/one-ping-one-ma.png");
          }
        }
        .js{
          position: absolute;
          top: 5px;
          right: 10px;
          font-size: 18px;
          color: @lightBlue;
          font-weight: bold;
          span{
            font-size: 14px;
            font-weight: normal;
          }
        }
        .right {
          /*padding-left: 170px;*/

          h3 {
            display: inline-block;
            color: @lightBlue;
            padding-bottom: 5px;
            font-size: 16px;
            font-weight: bold;
            letter-spacing: 1px;
          }

          span {
            display: inline-block;
            padding-left: 5px;
            line-height: 20px;
            color: @darkBlue;
            font-size: 18px;
            font-weight: bold;
            a{
              font-size: 14px;
              font-weight: normal;
            }
          }

          p {
            color: rgba(255, 255, 255, .5);
            font-size: 14px;
          }

          .btn {
            color: rgba(10, 170, 222, .5);
            font-size: 12px;
            cursor: pointer;
          }
        }
      }
      .list li:hover{
        background: #031621;
      }
    }

    .el-carousel__button {
      width: 8px;
      height: 8px;
      border-radius: 50%;
    }

    .el-carousel__indicators--outside button {
      background-color: #0a8b9c;
    }
    /*采购公示*/
    .publicity{
      &-title{
        font-size: 14px;
        color: #00b7ee;
        padding: 3px 8px 10px;
        span{
          padding: 0 4px;
          font-size: 18px;
          color: #2cff02;
        }
      }
      &-ul{
        max-height: 365px;
        min-height: 350px;
        overflow-y: auto;
        li{
          border-top: 1px solid #0b4045;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 10px 10px 5px;
          .li-l{
            p{
              color: @lightBlue;
              font-size: 16px;
              margin-bottom: 5px;
            }
            p:last-child{
              color: #a4a7a9;
              font-size: 14px;
              margin-bottom: 0;
            }
          }
          .li-l:hover{
            cursor: pointer;
          }
          .li-r{
            color: @lightBlue;
            font-size: 14px;
            span{
              font-size: 18px;
              color: #fff;
              padding: 0 4px;
            }
            i{
              color: #00b7ee;
              font-size: 20px !important;
              padding-left: 5px;
              cursor: pointer;
            }
          }
        }
        li:hover{
          background-color: #031621;
        }
      }
    }
    .pre-view{
      color: #00b7ee;
      font-size: 14px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
    }
    .hg{
      color: #2cff02;
    }
    .bhg{
      color: #ff7800;
    }
    .food-name{
      color: #00ffff;
    }
    .result{
      color: #00b7ee;
    }
    .time{
      color: #618496;
    }
    /*采购明细样式*/
    .buy-detail{
      position: absolute;
      right: 505px;
      top: -50px;
    }
    /*供应商信息样式*/
    .supp-info{
      position: absolute;
      right: 505px;
      top: -50px;
      .h1{
        font-size: 16px;
        color: @lightBlue;
        margin-bottom: 8px;
      }
      .info-detail{
        font-size: 14px;
        display: flex;
        margin-bottom: 8px;
        &-l{
          width: 105px;
          color: #a3a9ac;
        }
        &-r{
          color: #00b7ee;
        }
      }
      .imgs-list{
        display: flex;
        &-item{
          width: 31%;
          margin-right: 2%;
          cursor: pointer;
          div{
            width: 115px;
            height: 115px;
            overflow: hidden;
            display: flex;
            justify-content: center;
            align-items: center;
            img{
              object-fit: cover;
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }
    .el-table thead {
      color: #a3a9ac;
    }
    .el-table tr {
      background-color: #01212d00;
    }
    .el-table--enable-row-hover .el-table__body tr:hover>td {
      background-color: #031621;
    }
    .el-table th{
      padding: 4px 0;
    }
    .el-table td{
      padding: 2px 0;
    }
    .el-table td, .el-table th.is-leaf{
      border-bottom: none;
    }
    .el-table--border:after, .el-table--group:after, .el-table:before {
      content: "";
      position: absolute;
      background-color: rgba(0,0,0,0);
      z-index: 1;
    }
    .el-table--fit{
      background: none !important;
    }
    .has-gutter tr th {
      background-color: #002f40;
    }
    /*分页样式*/
    .el-pagination{
      text-align: center;
      margin-bottom: 6px;
    }
    .el-pagination.is-background .el-pager li {
      background-color: inherit;
      color: #0aaade;
      margin: 0;
      font-size: 14px;
      font-weight: normal;
    }
    .el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev{
      background: inherit;
      color: #0aaade;
      margin: 0;
    }
    .el-pagination.is-background .el-pager li:not(.disabled).active {
      background-color: #004270 !important;
      color: #00ffff;
    }
    .my-table {
      .el-table__body-wrapper{
        max-height: 400px !important;
        overflow: auto;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/shitang/todayRK.vue